@switch (currentStatus) {
  @case (0) {
    <div class="container-status border-gray-600 bg-gray-200">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="none"
            stroke="#4b5563"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8.56 3.69a9 9 0 0 0-2.92 1.95M3.69 8.56A9 9 0 0 0 3 12m.69 3.44a9 9 0 0 0 1.95 2.92m2.92 1.95A9 9 0 0 0 12 21m3.44-.69a9 9 0 0 0 2.92-1.95m1.95-2.92A9 9 0 0 0 21 12m-.69-3.44a9 9 0 0 0-1.95-2.92m-2.92-1.95A9 9 0 0 0 12 3"
          />
        </svg>
      </i>
      <p class="text-gray-600">
        <b>{{ 'productionCardStatus.draft' | translateWF: 'Draft' }}</b>
      </p>
    </div>
  }
  @case (1) {
    <div class="container-status border-[#0369a1] bg-[#036aa13b]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path fill="#0369a1" d="M17 3.34a10 10 0 1 1-14.995 8.984L2 12l.005-.324A10 10 0 0 1 17 3.34M12 10a2 2 0 0 0-1.977 1.697l-.018.154L10 12l.005.15A2 2 0 1 0 12 10" />
        </svg>
      </i>
      <p class="text-[#0369a1]">
        <b>{{ 'productionCardStatus.submitted' | translateWF: 'Submitted' }}</b>
      </p>
    </div>
  }
  @case (2) {
    <div class="container-status border-[#0eb855] bg-[#0eb8551a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <mask id="IconifyId195b928100d958c692">
            <g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path fill="#fff" d="M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z" />
              <path stroke="#000" stroke-dasharray="14" stroke-dashoffset="14" d="M8 12l3 3l5 -5">
                <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.2s" values="14;0" />
              </path>
            </g>
          </mask>
          <rect width="24" height="24" fill="#0eb855" mask="url(#IconifyId195b928100d958c692)" />
        </svg>
      </i>
      <p class="text-[#0eb855]">
        <b>{{ 'productionCardStatus.approved' | translateWF: 'Approved' }}</b>
      </p>
    </div>
  }
  @case (3) {
    <div class="container-status border-[#ffbf00] bg-[#f8dc071a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="#ffbf00"
            fill-rule="evenodd"
            d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m0 4a1 1 0 0 1 1 1v4.586l2.707 2.707a1 1 0 0 1-1.414 1.414L11 12.414V7a1 1 0 0 1 1-1"
            clip-rule="evenodd"
          />
        </svg>
      </i>
      <p class="text-[#ffbf00]">
        <b>{{ 'productionCardStatus.planningForBatching' | translateWF: 'Planning For Batching' }}</b>
      </p>
    </div>
  }
  @case (4) {
    <div class="container-status border-[#ffbf00] bg-[#b91c1c1a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="#ffbf00"
            d="M17 3.34a10 10 0 1 1-14.995 8.984L2 12l.005-.324A10 10 0 0 1 17 3.34m-6.489 5.8a1 1 0 0 0-1.218 1.567L10.585 12l-1.292 1.293l-.083.094a1 1 0 0 0 1.497 1.32L12 13.415l1.293 1.292l.094.083a1 1 0 0 0 1.32-1.497L13.415 12l1.292-1.293l.083-.094a1 1 0 0 0-1.497-1.32L12 10.585l-1.293-1.292l-.094-.083z"
          />
        </svg>
      </i>
      <p class="text-[#ffbf00]">
        <b>{{ 'productionCardStatus.inRouteToBatching' | translateWF: 'In Route To Batching' }}</b>
      </p>
    </div>
  }
  @case (5) {
    <div class="container-status border-[#ffbf00] bg-[#ffbf001a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
          <path
            fill="#ffbf00"
            d="M16 3C8.855 3 3 8.855 3 16s5.855 13 13 13s13-5.855 13-13S23.145 3 16 3m0 2c2.355 0 4.55.758 6.344 2.031a19.3 19.3 0 0 0-5.938-.5c-1.304.094-2.43.29-3.281.5c-.273.067-.45.125-.656.188a9.4 9.4 0 0 1-.156-1.563A10.9 10.9 0 0 1 16 5m-5.625 1.594a14 14 0 0 0 .344 1.906c-.004.2.05.395.156.563a16.6 16.6 0 0 0 1.625 3.843q.03.047.063.094a18.2 18.2 0 0 0 2.343 3.156c-.254.864-.566 1.66-.906 2.375c-.578-.527-1.309-1.304-2.094-2.437c-1.328-1.914-2.594-4.672-2.656-8.375a1 1 0 0 0-.063-.344c.368-.29.786-.54 1.188-.781m7.063 1.875c2.187-.047 4.824.293 7.468 1.562c.121.082.262.133.407.156c.32.508.609 1.032.843 1.594c-3.113-1.394-6-1.664-8.281-1.5a15 15 0 0 0-4.063.844A15 15 0 0 1 13 9.156c.195-.058.375-.125.625-.187c.75-.188 1.734-.387 2.906-.469c.293-.02.594-.023.907-.031M7.344 9.25c.34 3.41 1.59 6.07 2.906 7.969A16.7 16.7 0 0 0 13 20.312a15 15 0 0 1-1.406 1.782a17.7 17.7 0 0 1-2.344-2.907c-1.355-2.097-2.59-4.992-2.469-8.468a1 1 0 0 0-.093-.531c.203-.32.421-.641.656-.938m11.593 3c2.176-.027 4.844.402 7.72 2a.8.8 0 0 0 .187.094c.074.492.148.992.156 1.5c-1.309-.586-3.41-1.29-6.156-1.344a1 1 0 0 0-.594-.063a1 1 0 0 0-.188.063H20a18 18 0 0 0-3.469.469a16 16 0 0 1-1.687-2.094a14 14 0 0 1 4.094-.625zM5.126 14.406c.492 2.309 1.438 4.293 2.438 5.844a18.8 18.8 0 0 0 2.625 3.25c-.489.414-.899.71-1.22.938C6.544 22.418 5 19.39 5 16c0-.54.05-1.074.125-1.594zm16.219 2.125c.785.043 1.508.117 2.156.25c-.023.203-.047.39-.094.657a15 15 0 0 1-.812 2.843c-.86 2.168-2.422 4.676-5.344 6.407a1 1 0 0 0-.25.25A11 11 0 0 1 16 27c-.477 0-.945-.035-1.406-.094a16.74 16.74 0 0 0 5.469-6.468c.574-1.2.917-2.29 1.125-3.157c.07-.297.113-.515.156-.75zm-2.157.032c.043-.004.086.003.125 0c-.019.093-.039.148-.062.25a14 14 0 0 1-1 2.75c-1.008 2.105-2.781 4.585-6 6.468a1 1 0 0 0-.281.188c-.45-.18-.864-.39-1.281-.625c.324-.25.718-.57 1.124-.938a1 1 0 0 0 1.031-1a16.8 16.8 0 0 0 2.188-2.906a1 1 0 0 0 .188-.344c.566-1 1.066-2.144 1.469-3.437a16 16 0 0 1 2.5-.407zm6.25.78c.594.216 1.051.427 1.375.595a11 11 0 0 1-4.78 7.25a15.6 15.6 0 0 0 2.437-4.157c.488-1.23.75-2.351.906-3.218c.035-.192.04-.31.063-.47z"
          />
        </svg>
      </i>
      <p class="text-[#ffbf00]">
        <b>{{ 'productionCardStatus.batching' | translateWF: 'Batching' }}</b>
      </p>
    </div>
  }
  @case (6) {
    <div class="container-status border-[#ffbf00] bg-[#ffbf001a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
          <path
            fill="#ffbf00"
            d="M16 3C8.855 3 3 8.855 3 16s5.855 13 13 13s13-5.855 13-13S23.145 3 16 3m0 2c2.355 0 4.55.758 6.344 2.031a19.3 19.3 0 0 0-5.938-.5c-1.304.094-2.43.29-3.281.5c-.273.067-.45.125-.656.188a9.4 9.4 0 0 1-.156-1.563A10.9 10.9 0 0 1 16 5m-5.625 1.594a14 14 0 0 0 .344 1.906c-.004.2.05.395.156.563a16.6 16.6 0 0 0 1.625 3.843q.03.047.063.094a18.2 18.2 0 0 0 2.343 3.156c-.254.864-.566 1.66-.906 2.375c-.578-.527-1.309-1.304-2.094-2.437c-1.328-1.914-2.594-4.672-2.656-8.375a1 1 0 0 0-.063-.344c.368-.29.786-.54 1.188-.781m7.063 1.875c2.187-.047 4.824.293 7.468 1.562c.121.082.262.133.407.156c.32.508.609 1.032.843 1.594c-3.113-1.394-6-1.664-8.281-1.5a15 15 0 0 0-4.063.844A15 15 0 0 1 13 9.156c.195-.058.375-.125.625-.187c.75-.188 1.734-.387 2.906-.469c.293-.02.594-.023.907-.031M7.344 9.25c.34 3.41 1.59 6.07 2.906 7.969A16.7 16.7 0 0 0 13 20.312a15 15 0 0 1-1.406 1.782a17.7 17.7 0 0 1-2.344-2.907c-1.355-2.097-2.59-4.992-2.469-8.468a1 1 0 0 0-.093-.531c.203-.32.421-.641.656-.938m11.593 3c2.176-.027 4.844.402 7.72 2a.8.8 0 0 0 .187.094c.074.492.148.992.156 1.5c-1.309-.586-3.41-1.29-6.156-1.344a1 1 0 0 0-.594-.063a1 1 0 0 0-.188.063H20a18 18 0 0 0-3.469.469a16 16 0 0 1-1.687-2.094a14 14 0 0 1 4.094-.625zM5.126 14.406c.492 2.309 1.438 4.293 2.438 5.844a18.8 18.8 0 0 0 2.625 3.25c-.489.414-.899.71-1.22.938C6.544 22.418 5 19.39 5 16c0-.54.05-1.074.125-1.594zm16.219 2.125c.785.043 1.508.117 2.156.25c-.023.203-.047.39-.094.657a15 15 0 0 1-.812 2.843c-.86 2.168-2.422 4.676-5.344 6.407a1 1 0 0 0-.25.25A11 11 0 0 1 16 27c-.477 0-.945-.035-1.406-.094a16.74 16.74 0 0 0 5.469-6.468c.574-1.2.917-2.29 1.125-3.157c.07-.297.113-.515.156-.75zm-2.157.032c.043-.004.086.003.125 0c-.019.093-.039.148-.062.25a14 14 0 0 1-1 2.75c-1.008 2.105-2.781 4.585-6 6.468a1 1 0 0 0-.281.188c-.45-.18-.864-.39-1.281-.625c.324-.25.718-.57 1.124-.938a1 1 0 0 0 1.031-1a16.8 16.8 0 0 0 2.188-2.906a1 1 0 0 0 .188-.344c.566-1 1.066-2.144 1.469-3.437a16 16 0 0 1 2.5-.407zm6.25.78c.594.216 1.051.427 1.375.595a11 11 0 0 1-4.78 7.25a15.6 15.6 0 0 0 2.437-4.157c.488-1.23.75-2.351.906-3.218c.035-.192.04-.31.063-.47z"
          />
        </svg>
      </i>
      <p class="text-[#ffbf00]">
        <b>{{ 'productionCardStatus.inRouteToBrd' | translateWF: 'In Route To BRD' }}</b>
      </p>
    </div>
  }
  @case (7) {
    <div class="container-status border-[#ffbf00] bg-[#b91c1c1a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="#ffbf00"
            d="M17 3.34a10 10 0 1 1-14.995 8.984L2 12l.005-.324A10 10 0 0 1 17 3.34m-6.489 5.8a1 1 0 0 0-1.218 1.567L10.585 12l-1.292 1.293l-.083.094a1 1 0 0 0 1.497 1.32L12 13.415l1.293 1.292l.094.083a1 1 0 0 0 1.32-1.497L13.415 12l1.292-1.293l.083-.094a1 1 0 0 0-1.497-1.32L12 10.585l-1.293-1.292l-.094-.083z"
          />
        </svg>
      </i>
      <p class="text-[#ffbf00]">
        <b>{{ 'productionCardStatus.brd' | translateWF: 'BRD' }}</b>
      </p>
    </div>
  }
  @case (8) {
    <div class="container-status border-[#B91C1C] bg-[#B91C1C66]">
      <i>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="8" fill="#B91C1C" />
          <path d="M5.52468 10.4749L10.4744 5.52513M5.52468 5.52513L10.4744 10.4749" stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </i>
      <p class="text-[#B91C1C]">
        <b>{{ 'productionCardStatus.deleted' | translateWF: 'Deleted' }}</b>
      </p>
    </div>
  }
  @case (9) {
    <div class="container-status border-[#F8078C] bg-[#F8078C33]">
      <i>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="16" height="16" rx="8" fill="#F8078C" />
          <path d="M3 8L13 8" stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </i>
      <p class="text-[#F8078C]">
        <b>{{ 'productionCardStatus.rejected' | translateWF: 'Rejected' }}</b>
      </p>
    </div>
  }
  @case (10) {
    <div class="container-status border-[#FF7700] bg-[#FF770026]">
      <i>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.93401 15.4863C7.14355 15.4793 6.36243 15.3076 5.63671 14.9813C4.91099 14.655 4.25536 14.1807 3.70845 13.5864C2.59807 12.3736 1.98533 10.7579 2.00027 9.08232C2.01521 7.40676 2.65666 5.80321 3.78848 4.612L7.50185 0.737246C7.57422 0.656134 7.66227 0.591916 7.76022 0.548826C7.85816 0.505736 7.96376 0.484753 8.07006 0.487262C8.17651 0.488803 8.2816 0.512443 8.37917 0.556799C8.47674 0.601155 8.56482 0.665334 8.63827 0.745579L12.2876 4.67867C13.3991 5.89047 14.0132 7.50554 13.9998 9.1811C13.9863 10.8567 13.3463 12.4608 12.2156 13.6531C11.6587 14.2451 10.9919 14.7129 10.2558 15.0281C9.51976 15.3432 8.72979 15.4992 7.93401 15.4863Z"
            fill="#FF7700"
          />
        </svg>
      </i>
      <p class="text-[#FF7700]">
        <b>{{ 'productionCardStatus.dyeing' | translateWF: 'Dyeing' }}</b>
      </p>
    </div>
  }
  @case (11) {
    <div class="container-status border-[#0369A1] bg-[#0369A133]">
      <i>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.35006 10.535C7.14006 10.6983 6.84256 10.6983 6.63256 10.535L3.04506 7.74664C2.94347 7.66716 2.81821 7.62399 2.68923 7.62399C2.56025 7.62399 2.43498 7.66716 2.33339 7.74664C2.26391 7.80104 2.20772 7.87054 2.16908 7.94988C2.13043 8.02922 2.11035 8.11631 2.11035 8.20455C2.11035 8.2928 2.13043 8.37989 2.16908 8.45923C2.20772 8.53856 2.26391 8.60807 2.33339 8.66247L6.27673 11.7308C6.69673 12.0575 7.28589 12.0575 7.71173 11.7308L11.6551 8.66247C11.9526 8.42914 11.9526 7.97997 11.6551 7.74664L11.6492 7.7408C11.5476 7.66133 11.4224 7.61815 11.2934 7.61815C11.1644 7.61815 11.0391 7.66133 10.9376 7.7408L7.35006 10.535ZM7.71756 8.7733L11.6609 5.70497C11.9584 5.47164 11.9584 5.01664 11.6609 4.7833L7.71756 1.71497C7.29756 1.3883 6.70839 1.3883 6.28256 1.71497L2.33923 4.78914C2.04173 5.02247 2.04173 5.47747 2.33923 5.7108L6.28256 8.77914C6.70256 9.1058 7.29756 9.1058 7.71756 8.7733Z"
            fill="white"
          />
        </svg>
      </i>
      <p class="text-[#0369A1]">
        <b>{{ 'productionCardStatus.readyForFinishing' | translateWF: 'Ready For Finishing' }}</b>
      </p>
    </div>
  }
  @case (12) {
    <div class="container-status border-[#FF7700] bg-[#FF770026]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="#ffbf00"
            d="M17 3.34a10 10 0 1 1-14.995 8.984L2 12l.005-.324A10 10 0 0 1 17 3.34m-6.489 5.8a1 1 0 0 0-1.218 1.567L10.585 12l-1.292 1.293l-.083.094a1 1 0 0 0 1.497 1.32L12 13.415l1.293 1.292l.094.083a1 1 0 0 0 1.32-1.497L13.415 12l1.292-1.293l.083-.094a1 1 0 0 0-1.497-1.32L12 10.585l-1.293-1.292l-.094-.083z"
          />
        </svg>
      </i>
      <p class="text-[#FF7700]">
        <b>{{ 'productionCardStatus.finishing' | translateWF: 'Finishing' }}</b>
      </p>
    </div>
  }
  @case (13) {
    <div class="container-status border-[#0EB855] bg-[#0EB85533]">
      <i>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="1" y="1" width="14" height="14" rx="5" stroke="#0EB855" stroke-width="2" />
          <rect x="5" y="10.4871" width="6" height="2" rx="1" fill="#0EB855" />
        </svg>
      </i>
      <p class="text-[#0EB855]">
        <b>{{ 'productionCardStatus.finishedGood' | translateWF: 'Finished Good' }}</b>
      </p>
    </div>
  }
  @case (14) {
    <div class="container-status border-[#0EB855] bg-[#0EB85533]">
      <i>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM10.2002 5C9.97353 5 9.78631 5.07404 9.63965 5.2207C9.49317 5.36731 9.41994 5.55377 9.41992 5.78027C9.41992 6.00694 9.49298 6.19415 9.63965 6.34082L10.3594 7.06055H7.7998C7.57314 7.06055 7.38283 7.13671 7.22949 7.29004C7.07616 7.44337 7 7.63369 7 7.86035C7 8.08702 7.07616 8.27733 7.22949 8.43066C7.38283 8.584 7.57314 8.66016 7.7998 8.66016H10.3594L9.63965 9.37988C9.49298 9.52655 9.41992 9.71376 9.41992 9.94043C9.41994 10.1669 9.49317 10.3534 9.63965 10.5C9.78631 10.6467 9.97353 10.7207 10.2002 10.7207C10.4267 10.7206 10.6132 10.6466 10.7598 10.5L12.8398 8.41992C12.9997 8.25997 13.0801 8.07358 13.0801 7.86035C13.0801 7.64712 12.9997 7.46073 12.8398 7.30078L10.7598 5.2207C10.6132 5.07412 10.4267 5.00008 10.2002 5ZM3.7998 7.06055C3.35798 7.06055 3 7.41852 3 7.86035C3 8.30218 3.35798 8.66016 3.7998 8.66016H5.39941C5.84124 8.66016 6.2002 8.30218 6.2002 7.86035C6.2002 7.41852 5.84124 7.06055 5.39941 7.06055H3.7998Z"
            fill="#0EB855"
          />
        </svg>
      </i>
      <p class="text-[#0EB855]">
        <b>{{ 'productionCardStatus.shipped' | translateWF: 'Shipped' }}</b>
      </p>
    </div>
  }
  @case (15) {
    <div class="container-status border-[#6D28D9] bg-[#6D28D91a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path fill="#6D28D9" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m-1 14.5v-9l6.5 4.5z" />
        </svg>
      </i>
      <p class="text-[#6D28D9]">
        <b>{{ 'productionCardStatus.closed' | translateWF: 'Closed' }}</b>
      </p>
    </div>
  }
  @case (16) {
    <div class="container-status border-[#0891B2] bg-[#0891B21a]">
      <i>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
          <path
            fill="#0891B2"
            d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2m0 18a8 8 0 1 1 8-8a8 8 0 0 1-8 8m1-8.06V7a1 1 0 0 0-2 0v5.06A2 2 0 0 0 10 14a2 2 0 0 0 4 0a2 2 0 0 0-1-1.06"
          />
        </svg>
      </i>
      <p class="text-[#0891B2]">
        <b>{{ 'productionCardStatus.reassignment' | translateWF: 'Reassignment' }}</b>
      </p>
    </div>
  }
}
